import { FormRow } from 'ia-react-core';
import { FormSection } from 'omni-package-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Email from './Email';

export interface EditMailSectionProps { }

const EditMailSection: FC<EditMailSectionProps> = () => {
  const { t } = useTranslation('PersonalInformationsFormPage');

  return (
    <FormSection title={t('emails.title')} pb={12}>
      <FormRow>
        <Email mailType="home" required disableFlag="isEmailHomeReadOnly" />
        <Email mailType="work" disableFlag="isEmailWorkReadOnly" />
      </FormRow>
    </FormSection>
  );
};

export default EditMailSection;
